import type { IMatter } from '../interface/matter';
import { ITranslations } from '../interface/transactionTypes';

export enum InvoiceableType {
  billable = 'billable',
  nonBillable = 'non-billable',
  internal = 'internal',
}
export enum MatterRequestStatus {
  open = 'open',
  closed = 'closed',
  rejected = 'rejected',
}

export enum MatterStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
}
export function getTranslationFromTranslatableEntity(
  translations: ITranslations[] | undefined,
  appLanguage: string,
) {
  if (!translations) {
    return '-';
  }

  return (
    translations.find((translation) => translation.language.startsWith(appLanguage))?.translation ??
    translations.find((translation) => translation.language.startsWith(appLanguage))
      ?.nameTranslation ??
    translations.find((translation) => translation.language.startsWith('en'))?.translation ??
    translations.find((translation) => translation.language.startsWith('en'))?.nameTranslation ??
    '-'
  );
}

export function formatMatterReference(matter: IMatter | undefined) {
  return [matter?.matterNumber, matter?.subject].filter(Boolean).join(' - ');
}

export const matterBillingStatusTranslationMapping = {
  [InvoiceableType.billable]: 'matter:invoiceableType.billable',
  [InvoiceableType.nonBillable]: 'matter:invoiceableType.nonBillable',
  [InvoiceableType.internal]: 'matter:invoiceableType.internal',
};
